$(function ($) {
  var $trainingApp = $(".positronic-app.training");
  var curModuleInd = 0;
  var numModules = $(".lesson-module-wrap").length;

  // jump menu functions
  var scrollingToIndex = false;
  var autoUpdateJumpDisabled = false; // used to disable things while autoscrolling
  var $moduleJump = $(".module-jump-wrap > select");
  $moduleJump.on("change", function (e) {
    e.preventDefault();

    autoUpdateJumpDisabled = true;
    scrollToModule($moduleJump.val());
  });

  function scrollToModule(moduleIndex) {
    var $newModule = $('.lesson-module-wrap[data-id="' + moduleIndex + '"]');
    $("html, body").animate(
      {
        scrollTop: $newModule.offset().top,
      },
      1000
    );

    setTimeout(function () {
      autoUpdateJumpDisabled = false;
    }, 1000);
  }

  // forward/back arrows (keys too)
  function nextModule(isForward) {
    var nextModule = isForward ? curModuleInd + 1 : curModuleInd - 1;
    scrollToModule(nextModule);
  }

  $(document).on("keydown", function (e) {
    var keyCode = e.which ? e.which : e.keyCode;
    if (keyCode == 37) {
      e.preventDefault();
      nextModule(false);
    } else if (keyCode == 39 || keyCode == 32) {
      e.preventDefault();
      nextModule(true);
    }
  });
  $(".module-nav.back").on("click", function (e) {
    e.preventDefault();
    nextModule(false);
  });
  $(".module-nav.next").on("click", function (e) {
    e.preventDefault();
    nextModule(true);
  });

  // listener
  $trainingApp.on(TRAINING_EVENTS.NEW_MODULE, function (e, newModule) {
    // update current
    curModuleInd = newModule.index;

    // jump to dropdown
    if (!autoUpdateJumpDisabled) $moduleJump.val(curModuleInd);
    if (curModuleInd == scrollingToIndex) autoUpdateJumpDisabled = false;

    // next/back arrows
    if (curModuleInd == 0) $(".module-nav.back").addClass("disabled");
    else $(".module-nav.back").removeClass("disabled");

    if (curModuleInd == numModules - 1)
      $(".module-nav.next").addClass("disabled");
    else $(".module-nav.next").removeClass("disabled");
  });

  window.posiNextModule = nextModule;
});
